import Axioscall from './Axios';
//login with credentials

export const loginApi = userData => {
  return Axioscall.post('auth/login', userData);
};

//forgot password api

export const forgotPasswordApi = userEmail => {
  return Axioscall.post('auth/forgotPassword', userEmail);
};

//Role list api

export const roleListApi = (page, search) => {
  return Axioscall.get(`role/list?search=${search}&page=${page}&limit=10`);
};

//Role list api

export const admiRoleListApi = () => {
  return Axioscall.get(`role/list`);
};

//add admin api

export const addAdminApi = adminDetails => {
  return Axioscall.post('user/add', adminDetails);
};

//edit admin api

export const editAdminApi = (adminDetails, id) => {
  return Axioscall.put(`user/edit/${id}`, adminDetails);
};

// Get all Roles
export const getAllRoles = () => {
  return Axioscall.get(`role/list`);
};

//Role activity list api

export const roleActivityListApi = page => {
  return Axioscall.get(`common/listLog/role?page=${page}&limit=10`);
};

// Admin List api with filteration

export const adminListApi = (search, roleId, status, page) => {
  return Axioscall.get(
    `user/list?search=${search}&roleId=${roleId}&status=${status}&page=${page}&limit=10`,
  );
};

//Admin assign bulk role to user api
export const assignbulkRoleApi = bulkData => {
  return Axioscall.patch(`user/edit/bulkEdit`, bulkData);
};

//add role api

export const addRoleApi = roleDetails => {
  return Axioscall.post('role/add', roleDetails);
};

//edit role api

export const editRoleApi = (id, roleDetails) => {
  return Axioscall.patch(`role/edit/${id}`, roleDetails);
};

//delete role api

export const deleteRoleApi = id => {
  return Axioscall.delete(`role/delete/${id}`);
};

//role permission list api

export const getrolenFeatureApi = () => {
  return Axioscall.get(`common/listFeature`);
};

//detail view role api

export const viewRoleDetail = id => {
  return Axioscall.get(`role/view/${id}`);
};

//Get users api
export const userDetailsApi = () => {
  return Axioscall.get(`profile/view`);
};

// Get Activity Log
export const getActivityLog = page => {
  return Axioscall.get(`common/listLog/profile?page=${page}&limit=10`);
};

// Generate Mfa Code
export const generateMfaCode = () => {
  return Axioscall.post(`user/generateMfaCode`, {
    authType: 'App',
  });
};

// Verify Mfa Code
export const verifyAppMfaCode = (userId, code, authToken) => {
  return Axioscall.post(`user/verifyAuthentication`, {
    userId: userId,
    code: code,
    authType: 'App',
    authToken: authToken,
    isLogin: 0,
  });
};

// Login Mfa Code
export const loginMfa = (userId, code, authType) => {
  return Axioscall.post(`user/verifyAuthentication`, {
    userId: userId,
    code: code,
    authType: authType,
    // authToken: authToken,
    isLogin: 1,
  });
};

// Edit User Info
export const editUserInfo = formData => {
  return Axioscall.patch(`profile/edit`, formData, {
    headers: {
      'content-type': 'multipart/form-data',
    },
  });
};

// Delete Profile Pic
export const deleteProfilePicApi = () => {
  return Axioscall.delete(`profile/deleteImage`);
};

// Change Password API
export const changePasswordApi = (oldPassword, newPassword) => {
  return Axioscall.post(`profile/changePassword`, {
    oldPassword: oldPassword,
    newPassword: newPassword,
  });
};
// Logout
export const logoutApi = () => {
  return Axioscall.get(`profile/logout`);
};

//detail view admin api

export const viewAdminDetail = id => {
  return Axioscall.get(`user/view/${id}`);
};

//deactive user api

export const deactiveAdminApi = id => {
  return Axioscall.post(`user/deactivate/${id}`);
};

//active user api

export const activeAdminApi = id => {
  return Axioscall.post(`user/activate/${id}`);
};

//invite active user api

export const inviteActiveAdminApi = id => {
  return Axioscall.post(`user/invite/${id}`);
};

// Get Activity Log
export const getAdminActivityLog = () => {
  return Axioscall.get(`common/listLog/user`);
};

//resetpassword api
export const resetPasswordApi = tokenData => {
  return Axioscall.post(`auth/resetPassword`, tokenData);
};

//setpassword api
export const setPasswordApi = tokenData => {
  return Axioscall.post(`user/setPassword`, tokenData);
};

//link expiry api
export const validateResetPasswordToken = token => {
  return Axioscall.post(`auth/verifyLinkExpiry`, { token });
};

//Get Tenant List
export const getTenantListApi = (search, subscription, status, page) => {
  return Axioscall.get(
    `tenant/list?search=${search}&subscription=${subscription}&status=${status}&page=${page}&limit=10`,
  );
};

//Get Tenant List
// export const getTenantListApi = (page) => {
//   return Axioscall.get(`tenant/list?page=${page}&limit=10`);
// };

//Add Tenant Details
export const addTenantApi = tenantDetails => {
  return Axioscall.post(`tenant/add`, tenantDetails);
};

//View Tenant Details
export const viewTenantApi = id => {
  return Axioscall.get(`tenant/view/${id}`);
};

//Tenant Status  Api
export const tenantStatusApi = (id, status) => {
  return Axioscall.patch(`tenant/edit/toggleStatus/${id}`, { status: status });
};

//Subtscription Plan List Api
export const subscriptionPlanListApi = () => {
  return Axioscall.get(`plan/list`);
};

//Tenant Delete Api
export const tenantDeleteApi = id => {
  return Axioscall.delete(`tenant/delete/${id}`);
};

//Tenant Edit Api
export const tenantEditApi = (id, tenantDetails) => {
  return Axioscall.put(`tenant/edit/${id}`, tenantDetails);
};

// Tenant Activity Log
export const getTenantActivityLog = page => {
  return Axioscall.get(`common/listLog/tenant?page=${page}&limit=10`);
};

//add plan
export const addPlanApi = planData => {
  return Axioscall.post(`plan/add`, planData);
};

//plan feature list
export const getPlanFeatures = () => {
  return Axioscall.get(`common/listPlanFeatures`);
};

//edit plan
export const editPlanApi = (id, planData) => {
  return Axioscall.patch(`plan/edit/${id}`, planData);
};

//list plan
export const listPlanApi = (page, status, subscriberCount) => {
  return Axioscall.get(
    `plan/list?page=${page}&status=${status}&subscriberCount=${subscriberCount}&limit=10`,
  );
};

//detail plan
export const planViewApi = id => {
  return Axioscall.get(`plan/view/${id}`);
};

//delete paln
export const deletePlanApi = id => {
  return Axioscall.delete(`plan/delete/${id}`);
};

//active plan api

export const planStatusApi = (id, status) => {
  return Axioscall.patch(`plan/edit/toggleStatus/${id}`, { status: status });
};

// COMMON

//Common Role List paln
export const commonRoleList = () => {
  return Axioscall.get(`common/getRoles`);
};

//Common Plan List paln
export const commonPlanList = () => {
  return Axioscall.get(`common/getPlans`);
};

// delete user
export const deleteUserApi = id => {
  return Axioscall.delete(`user/delete/${id}`);
};
// Get all Inverters list
export const getAllInverterList = (page, status, search) => {
  return Axioscall.get(
    `product/list/inverters?search=${search}&status=${status}&page=${page}&limit=10`,
  );
};

// Get all Battery list
export const getAllBatteryList = (page, status, search) => {
  return Axioscall.get(
    `product/list/battery?search=${search}&status=${status}&page=${page}&limit=10`,
  );
};

// get dealers list
export const getDealersList = (page, status, search) => {
  return Axioscall.get(
    `dealer/list?search=${search}&status=${status}&page=${page}&limit=10`,
  );
};

//dealer details
export const dealerDetailsApi = id => {
  return Axioscall.get(`dealer/view/${id}`);
};

// delete dealer
export const deleteDealerApi = id => {
  return Axioscall.delete(`dealer/delete/${id}`);
};
// dealer status updation
export const dealerStatusChangeApi = (status, id) => {
  return Axioscall.put(`dealer/updatestatus/${id}`, status);
};
// add dealer
export const addDealerApi = data => {
  return Axioscall.post(`dealer/add`, data);
};
// edit dealer
export const updateDealerApi = (id, data) => {
  return Axioscall.put(`dealer/edit/${id}`, data);
};

export const bulkUploadApi = formData => {
  return Axioscall.post('/common/dealerBulkUpload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

//product details
export const productDetailsApi = (type, id) => {
  return Axioscall.get(`product/view/${type}/${id}`);
};

// product status updation
export const productStatusChangeApi = (data, id) => {
  return Axioscall.put(`product/updatestatus/${id}`, data);
};
// product dealer
export const deleteProductApi = (id, data) => {
  return Axioscall.delete(`product/delete/${id}`, { data });
};

// add inverter
export const addInverterApi = data => {
  return Axioscall.post(`product/add/inverter`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
// add battery
export const addBatteryApi = data => {
  return Axioscall.post(`product/add/battery`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
// export const updateInverter
export const updateInverterApi = (id, data) => {
  return Axioscall.patch(`product/edit/inverter/${id}`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
// export const update battery
export const updateBatteryApi = (id, data) => {
  return Axioscall.patch(`product/edit/battery/${id}`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
// verify phone number
export const verifyPhoneNumberAPI = phone => {
  return Axioscall.post(`profile/sendMobileVerifyOtp`, phone);
};
// verify otp
export const verifyOtpAPI = otp => {
  return Axioscall.post(`user/verifyMobileOtp`, otp);
};

//dashboard monthly user
export const dashboardMonthlyUser = year => {
  return Axioscall.get(`dashboard/usersPerYear`, { params: { year } });
};

//dashboard recommanded status
export const dashboardRecommandedStatus = () => {
  return Axioscall.get(`dashboard/mostRecommended`);
};

//dashboard user details
export const dashBoardUserData = (page, search) => {
  return Axioscall.get(
    `dashboard/contactedUsers?search=${search}&page=${page}&limit=10`,
  );
};

//download user list
export const downloadUsers = (search) => {
  return Axioscall.get(`common/downloadUsers?search=${search}`);
};

// Get all Combo list
export const getAllComboList = (page, status, search) => {
  return Axioscall.get(
    `product/list/comboProducts?search=${search}&status=${status}&page=${page}&limit=10`,
  );
};

// add combo
export const addComboApi = data => {
  return Axioscall.post(`product/add/comboProduct`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// export const update combo
export const updateComboApi = (id, data) => {
  return Axioscall.patch(`product/edit/comboProduct/${id}`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
